import Translator from '../../classes/Translator/Translator';

const IntegrityPillarsLogic = () => {
  const { translator } = Translator();

  return {
    translator,
  };
};

export default IntegrityPillarsLogic;
